import { callApi } from "modules/core/api/services";
import { ApiResponse } from "modules/core/api/types";
import { Event } from "types/interfaces/Event";
import { EventPlayout } from "../types";

export const eventByUuid = (eventUuid: string) =>
  callApi<Event>(`/v2/events/${eventUuid}`);

export const eventPlayoutByUuid = (eventUuid: string) =>
  callApi<EventPlayout>(`/v2/event_playouts/${eventUuid}`);

export const upcomingEvents = (sportUuid: string) =>
  callApi<ApiResponse<Event[]>>(
    `/v2/${sportUuid}/events?event_type=upcoming&resource_type=sport&page=1&per_page=10`
  );

export const liveEvents = (sportUuid: string) =>
  callApi<ApiResponse<Event[]>>(
    `/v2/${sportUuid}/events?event_type=live&resource_type=sport&page=1&per_page=10`
  );

export const latestEvents = (sportUuid: string) =>
  callApi<ApiResponse<Event[]>>(
    `/v2/${sportUuid}/events?event_type=latest&resource_type=sport&page=1&per_page=10`
  );

export const eventsHighlight = (sportUuid: string) =>
  callApi<ApiResponse<any[]>>(
    `/v2/${sportUuid}/events?event_type=highlights&resource_type=sport&page=1&per_page=10`
  );
